var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"text-center",attrs:{"colspan":_vm.colspan}},[_c('i',{staticClass:"fas fa-spinner fa-spin"})])])}
var staticRenderFns = []

export { render, staticRenderFns }